import { QuestionCircleOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import React from 'react';

export const QuestionTooltip = ({
  title,
}: {
  title: string;
}): React.JSX.Element => (
  <Tooltip title={title}>
    <QuestionCircleOutlined />
  </Tooltip>
);
